export default "__VITE_ASSET__iWTh3joS__"